import { Marquee } from "./Marquee";
import { useLang } from "./i18n";

const COLS = [
  ["ft.shop", [["nav.new", "https://www.offgridcb.store/collections/all"], ["nav.collections", "https://www.offgridcb.store/collections"], ["nav.cart", "https://www.offgridcb.store/cart"]]],
  ["ft.info", [["ft.ship", "https://www.offgridcb.store/policies/shipping-policy"], ["ft.terms", "https://www.offgridcb.store/policies/terms-of-service"], ["ft.contact", "https://www.offgridcb.store/pages/contact"]]],
  ["ft.social", [["Instagram", "#"], ["TikTok", "#"]]],
];

export const Footer = () => {
  const { t } = useLang();
  return (
  <footer data-testid="site-footer" className="bg-[#050505] text-white border-t border-white/10">
    <Marquee items={["WELCOME TO OFF GRID", t("ft.thanks"), "WELCOME TO OFF GRID", "REAL TIME ONLY"]} variant="outline" speed={60} sep="—" />
    <div className="px-5 md:px-10 py-16 grid md:grid-cols-12 gap-10">
      <div className="md:col-span-5 flex items-start gap-4">
        <img src="/img/logo-white.png" alt="Off Grid" className="w-20 h-20" />
        <p className="text-zinc-400 text-sm max-w-xs leading-relaxed">{t("ft.desc")}</p>
      </div>
      {COLS.map(([tt, links]) => (
        <div key={tt} className="md:col-span-2">
          <div className="f-mono text-xs tracking-[0.3em] text-[#FF2A2A] mb-4 uppercase">{t(tt)}</div>
          <ul className="space-y-2">
            {links.map(([l, h]) => (
              <li key={l}><a href={h} target="_blank" rel="noreferrer" data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="og-link text-sm text-zinc-300">{t(l)}</a></li>
            ))}
          </ul>
        </div>
      ))}
    </div>
    <div className="px-5 md:px-10 overflow-hidden">
      <div className="f-goth text-[27vw] leading-[0.75] text-[#F5F5F7] text-center select-none">Off Grid</div>
    </div>
    <div className="px-5 md:px-10 py-6 flex flex-col sm:flex-row justify-between gap-2 f-mono text-[11px] tracking-[0.2em] text-zinc-400 border-t border-white/10">
      <span>{t("ft.rights")}</span>
      <span>OFFLINE / REAL TIME ONLY</span>
    </div>
  </footer>
  );
};
